import PageNavBackLayoutCpt from '@/components/page/PageNavBackLayoutCpt';
import ListViewCpt from '@/components/list/ListViewCpt';
import PopSelect from '@/components/pop-select';
import { rqtPostListProductPage } from '@/services/wms/product';
import { rqtPostProductListForSelect } from '@/services/wms/product';
import { rqtPostPartnerQuery } from "@/services/ams/partner";
import cptCmn from '@/mixin/cpt-cmn';
export default {
  components: {
    PageNavBackLayoutCpt,
    ListViewCpt,
    PopSelect
  },
  mixins: [cptCmn],
  data() {
    return {
      showPopup: false,
      btnLoading: false,
      listRequest: rqtPostListProductPage,
      codeResItems: [{
        title: '产品子类',
        dataIndex: 'productSubType',
        dataType: 'select',
        dataRes: undefined,
        dataResItem: {
          key: 'code',
          title: 'codeName'
        },
        dataResCodeType: 'productSubType'
      }, {
        title: '产品形态',
        dataIndex: 'productForm',
        dataType: 'select',
        dataRes: undefined,
        dataResItem: {
          key: 'code',
          title: 'codeName'
        },
        dataResCodeType: 'productForm'
      },
      // {
      //   title: '审核状态',
      //   dataIndex: 'productAuditStatus',
      //   dataType: 'select',
      //   dataRes: undefined,
      //   dataResItem: {
      //     key: 'code',
      //     title: 'codeName'
      //   },
      //   dataResCodeType: 'productAuditStatus'
      // },
      {
        title: '产品状态',
        dataIndex: 'productStatus',
        dataType: 'select',
        dataRes: undefined,
        dataResItem: {
          key: 'code',
          title: 'codeName'
        },
        dataResCodeType: 'productStatus'
      }, {
        title: '产品类型',
        dataIndex: 'productType',
        dataType: 'select',
        dataRes: undefined,
        dataResItem: {
          key: 'code',
          title: 'codeName'
        },
        dataResCodeType: 'productType'
      }, {
        title: '产品子类型',
        dataIndex: 'productSubType',
        dataType: 'select',
        dataRes: undefined,
        dataResItem: {
          key: 'code',
          title: 'codeName'
        },
        dataResCodeType: 'productSubType'
      }, {
        title: '产品形态',
        dataIndex: 'productForm',
        dataType: 'select',
        dataRes: undefined,
        dataResItem: {
          key: 'code',
          title: 'codeName'
        },
        dataResCodeType: 'productForm'
      }, {
        title: '产品类别',
        dataIndex: 'wealthCategory',
        dataType: 'select',
        dataRes: undefined,
        dataResItem: {
          key: 'code',
          title: 'codeName'
        },
        dataResCodeType: 'wealthCategory'
      }, {
        title: '募集机构',
        dataIndex: 'raisedOrganization',
        dataType: 'select',
        dataRes: undefined,
        dataResItem: {
          key: 'code',
          title: 'codeName'
        },
        dataResCodeType: 'raisedOrganization'
      }],
      searchForm: {
        partnerCode: null,
        productId: null,
        productName: null,
        productType: null,
        productSubType: null,
        productStatus: null,
        productAuditStatus: '03',
        productForm: null,
        wealthCategory: null,
        raisedOrganization: null,
        publishIsSet: null
      },
      searchItems: [{
        title: '合作机构',
        type: 'dropdown',
        name: 'partnerCode',
        request: rqtPostPartnerQuery,
        keyName: 'partnerCode',
        valueName: 'partnerName',
        selectedOptions: []
      }, {
        title: '产品',
        type: 'dropdown',
        name: 'productId',
        request: rqtPostProductListForSelect,
        keyName: 'id',
        valueName: 'productName',
        paramName: 'param',
        selectedOptions: []
      }, {
        title: '产品类型',
        type: 'flatSelect',
        name: 'productType',
        mutiSelect: false,
        options: [],
        selectedOptions: []
      }, {
        title: '产品子类型',
        type: 'flatSelect',
        name: 'productSubType',
        mutiSelect: false,
        options: [],
        selectedOptions: []
      }, {
        title: '产品状态',
        type: 'flatSelect',
        name: 'productStatus',
        mutiSelect: false,
        options: [],
        selectedOptions: []
      }, {
        title: '审核状态',
        type: 'flatSelect',
        name: 'productAuditStatus',
        mutiSelect: false,
        options: [{
          value: '审核发布',
          key: '03'
        }],
        selectedOptions: []
      }, {
        title: '产品形态',
        type: 'flatSelect',
        name: 'productForm',
        mutiSelect: false,
        options: [],
        selectedOptions: []
      }, {
        title: '产品类别',
        type: 'flatSelect',
        name: 'wealthCategory',
        mutiSelect: false,
        options: [],
        selectedOptions: []
      }, {
        title: '募集机构',
        type: 'flatSelect',
        name: 'raisedOrganization',
        mutiSelect: false,
        options: [],
        selectedOptions: []
      }, {
        title: '信披设置',
        type: 'flatSelect',
        name: 'publishIsSet',
        mutiSelect: false,
        options: [{
          value: '已设置',
          key: '01'
        }, {
          value: '未设置',
          key: '02'
        }],
        selectedOptions: []
      }]
    };
  },
  mounted() {
    this.initResCodeType(this.codeResItems).then(res => {
      for (let item of this.searchItems) {
        for (let codeItem of res) {
          if (item.name == codeItem.dataIndex) {
            item.options = codeItem.dataRes.map(e => {
              return {
                key: e.code,
                value: e.codeName
              };
            });
            break;
          }
        }
      }
    });
  },
  computed: {
    noCondition() {
      for (let selectItem of this.searchItems) {
        if (selectItem.selectedOptions.length > 0) {
          return false;
        }
      }
      return true;
    }
  },
  methods: {
    showCondition() {
      this.showPopup = true;
    },
    onListDataChange() {
      if (this.btnLoading) {
        this.btnLoading = false;
      }
    },
    onSearch() {
      this.btnLoading = true;
      this.$refs['ListViewCpt'].initListData();
    },
    handlePopSelectConfirm(searchItems) {
      for (let searchItem of searchItems) {
        this.searchForm[searchItem.name] = searchItem.selectedOptions[0];
      }
      this.$refs['ListViewCpt'].initListData();
      this.showPopup = false;
    }
  }
};